<template>
  <div id="Hotspot">
    <Head />
    <div class="hotspot clear">
      <Nav ms="/Bgmyproject" />
      <div class="H-right">
        <div class="title">我的成果管理</div>
        <div
          v-if="tableData1.length > 0 && id == '1'"
          class="btn2"
          @click="downLoadAll()"
        >
          <i></i>
          一键下载
        </div>
        <div v-if="tableData1.length > 0" class="btn1" @click="exportExcel()">
          <i></i>
          导出数据
        </div>
        <div class="select">
          <el-date-picker
            v-model="year"
            type="year"
            @change="setYear"
            :default-value="value"
            value-format="yyyy"
            :picker-options="pickerOptions"
            placeholder="请选择"
            :clearable="false"
          >
          </el-date-picker>
          <div class="sum" v-show="tableData1.length > 0">
            总计{{ tableData1.length }}个成果
          </div>
        </div>
        <div class="t_main">
          <el-table
            v-if="usertype == 1"
            id="table"
            border
            max-height="1200"
            :header-cell-style="{
              'background-color': '#001743',
              color: '#fff',
              height: '0.5rem',
            }"
            :stripe="true"
            :data="tableData1"
            style="width: 100%"
            :row-style="{ height: '0.4rem' }"
          >
            <el-table-column
              type="index"
              width="60"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>

            <el-table-column
              prop="ID"
              width="100"
              label="成果编号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="gs2j"
              label="一级公司"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="gs3j"
              label="二级公司"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="gs4j"
              label="三级公司"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="CompanyName"
              label="完成单位"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="Classname"
              label="成果分类"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="Title"
              label="课题名称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="zycsr"
              label="主要创造人"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              label="参与创造人"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.cycsr }}</span>
              </template>
            </el-table-column>

            <el-table-column
              width="100"
              prop="DeclarTime"
              label="申报时间"
              header-align="center"
              align="center"
            ></el-table-column>
          </el-table>
          <el-table
            v-if="usertype != 0 && usertype != 1"
            border
            :header-cell-style="{
              'background-color': '#001743',
              color: '#fff',
              height: '0.5rem',
            }"
            :stripe="true"
            :data="tableData1"
            style="width: 100%"
            :row-style="{ height: '0.4rem' }"
            max-height="600"
          >
            <el-table-column
              type="index"
              width="60"
              label="编号"
              header-align="center"
              align="center"
            ></el-table-column>
            <!-- <el-table-column prop="gs2j" label="二级公司" header-align='center' align='center'></el-table-column>
            <el-table-column prop="gs3j" label="三级公司" header-align='center' align='center'></el-table-column>-->
            <el-table-column
              prop="CompanyName"
              label="完成单位"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="Classname"
              label="成果分类"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="Title"
              label="课题名称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="zycsr"
              label="主要创造人"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsr"
              label="参与创造人"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              width="100"
              prop="DeclarTime"
              label="申报时间"
              header-align="center"
              align="center"
            ></el-table-column>
          </el-table>
          <!-- <el-table  v-if="usertype==3" border :header-cell-style="{'background-color': '#001743','color': '#fff','height':'0.5rem'}" :stripe="true" :data="tableData1" style="width: 100%;" :row-style="{'height':'0.4rem'}">             
           
            <el-table-column type="index" width="60" label="编号" header-align='center' align='center'></el-table-column>
            <el-table-column prop="gs3j" label="三级公司" header-align='center' align='center'></el-table-column>
            <el-table-column prop="CompanyName" label="完成单位" header-align='center' align='center'></el-table-column>
            <el-table-column prop="Classname" label="成果分类" header-align='center' align='center'></el-table-column>
            <el-table-column prop="Title" label="课题名称" header-align='center' align='center'></el-table-column>
            <el-table-column prop="zycsr" label="主要创造人" header-align='center' align='center'></el-table-column>
            <el-table-column prop="cycsr" label="参与创造人" header-align='center' align='center'></el-table-column>
            <el-table-column width="100" prop="DeclarTime" label="申报时间" header-align='center' align='center'></el-table-column>
            
          </el-table> 
            <el-table  v-if="usertype==4" border :header-cell-style="{'background-color': '#001743','color': '#fff','height':'0.5rem'}" :stripe="true" :data="tableData1" style="width: 100%;" :row-style="{'height':'0.4rem'}">             
           
            <el-table-column type="index" width="60" label="编号" header-align='center' align='center'></el-table-column>
            <el-table-column prop="Department" label="申报部门" header-align='center' align='center'></el-table-column>
            <el-table-column prop="Classname" label="成果分类" header-align='center' align='center'></el-table-column>
            <el-table-column prop="Title" label="课题名称" header-align='center' align='center'></el-table-column>
            <el-table-column prop="zycsr" label="主要创造人" header-align='center' align='center'></el-table-column>
            <el-table-column prop="cycsr" label="参与创造人" header-align='center' align='center'></el-table-column>
            <el-table-column width="100" prop="DeclarTime" label="申报时间" header-align='center' align='center'></el-table-column>
            
          </el-table>-->
          <el-table
            v-if="usertype == 0"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            border
            :header-cell-style="{
              'background-color': '#001743',
              color: '#fff',
              height: '0.1rem',
            }"
            :stripe="true"
            :data="tableData1"
            style="width: 100%"
            :row-style="{ height: '0.4rem' }"
            max-height="600"
          >
            <!-- <el-table-column
              type="index"
              width="60"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column> -->
            <el-table-column
              prop="accessNo"
              width="100"
              label="评审编号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ID"
              width="100"
              label="成果编号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="gs1j"
              label="央企/省份"
              header-align="center"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="gs2j"
              label="一级公司"
              header-align="center"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="gs3j"
              label="二级公司"
              header-align="center"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="gs4j"
              label="三级公司"
              header-align="center"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="CompanyName"
              label="完成单位"
              header-align="center"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="cgfl"
              label="成果分类"
              header-align="center"
              align="center"
              width="300"
            ></el-table-column>
            <el-table-column
              prop="Title"
              label="成果名称"
              header-align="center"
              align="center"
              width="200"
            ></el-table-column>

            <el-table-column
              label="专家1姓名"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope" v-if="scope.row.zjs[0]">
                <p>{{ scope.row.zjs[0].name }}</p>
              </template>
            </el-table-column>
            <el-table-column label="评分" header-align="center" align="center">
              <template slot-scope="scope" v-if="scope.row.zjs[0]">
                <p>{{ scope.row.zjs[0].score }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="专家2姓名"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope" v-if="scope.row.zjs[1]">
                <p>{{ scope.row.zjs[1].name }}</p>
              </template>
            </el-table-column>
            <el-table-column label="评分" header-align="center" align="center">
              <template slot-scope="scope" v-if="scope.row.zjs[1]">
                <p>{{ scope.row.zjs[1].score }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="专家3姓名"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope" v-if="scope.row.zjs[2]">
                <p>{{ scope.row.zjs[2].name }}</p>
              </template>
            </el-table-column>
            <el-table-column label="评分" header-align="center" align="center">
              <template slot-scope="scope" v-if="scope.row.zjs[2]">
                <p>{{ scope.row.zjs[2].score }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="专家4姓名"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope" v-if="scope.row.zjs[3]">
                <p>{{ scope.row.zjs[3].name }}</p>
              </template>
            </el-table-column>
            <el-table-column label="评分" header-align="center" align="center">
              <template slot-scope="scope" v-if="scope.row.zjs[3]">
                <p>{{ scope.row.zjs[3].score }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="专家5姓名"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope" v-if="scope.row.zjs[4]">
                <p>{{ scope.row.zjs[4].name }}</p>
              </template>
            </el-table-column>
            <el-table-column label="评分" header-align="center" align="center">
              <template slot-scope="scope" v-if="scope.row.zjs[4]">
                <p>{{ scope.row.zjs[4].score }}</p>
              </template>
            </el-table-column>
            <!-- <el-table-column label="专家评分" header-align="center" align="center" width="200">
              <template slot-scope="scope">
                <ul>
                  <li v-for="(item,i) in scope.row.zjs" :key="i">{{item}}</li>
                </ul>
              </template>
            </el-table-column>-->
            <el-table-column
              prop="tjdw"
              label="成果推荐单位"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="csrxm1"
              label="主要创造人1"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="csrzw1"
              label="职务"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="csrzc1"
              label="职称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="csrxm2"
              label="主要创造人2"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="csrzw2"
              label="职务"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="csrzc2"
              label="职称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrxm1"
              label="参与创造人1"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzw1"
              label="职务"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzc1"
              label="职称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrxm2"
              label="参与创造人2"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzw2"
              label="职务"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzc2"
              label="职称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrxm3"
              label="参与创造人3"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzw3"
              label="职务"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzc3"
              label="职称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrxm4"
              label="参与创造人4"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzw4"
              label="职务"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzc4"
              label="职称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrxm5"
              label="参与创造人5"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzw5"
              label="职务"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzc5"
              label="职称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrxm6"
              label="参与创造人6"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzw6"
              label="职务"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzc6"
              label="职称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrxm7"
              label="参与创造人7"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzw7"
              label="职务"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzc7"
              label="职称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrxm8"
              label="参与创造人8"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzw8"
              label="职务"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzc8"
              label="职称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrxm9"
              label="参与创造人9"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzw9"
              label="职务"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzc9"
              label="职称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrxm10"
              label="参与创造人10"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzw10"
              label="职务"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cycsrzc10"
              label="职称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sbdwlx"
              label="申报单位类型"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sbdwgm"
              label="申报单位规模"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sbdwdz"
              label="申报单位详细地址"
              header-align="center"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="yb"
              label="邮编"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sblxrxm"
              label="联系人"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sblxrzw"
              label="部门及职务"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sblxrdh"
              label="电话"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sblxrsj"
              label="手机"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sblxrcz"
              label="传真"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="dzyx"
              label="电子邮箱"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cgsyjl"
              label="本成果何时经过何单位、何种鉴定，获何奖项"
              header-align="center"
              align="center"
              width="200"
            >
              <template #default="scope">
                <el-tooltip effect="dark" placement="top">
                  <template #content>
                    <div class="set-popper">{{ scope.row.cgsyjl }}</div>
                  </template>
                  <div class="set-content">{{ scope.row.cgsyjl }}</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="cgczsj"
              label="成果创造时间"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cgyynx"
              label="成果应用年限"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cgssfw"
              label="成果实施范围"
              header-align="center"
              align="center"
              width="200"
            >
              <template #default="scope">
                <el-tooltip effect="dark" placement="top">
                  <template #content>
                    <div class="set-popper">{{ scope.row.cgssfw }}</div>
                  </template>
                  <div class="set-content">{{ scope.row.cgssfw }}</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="sbqynxye"
              label="申报前一年效益额（万元）"
              header-align="center"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="ssgnljxye"
              label="实施各年累计效益额（万元）"
              header-align="center"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="pjndxye"
              label="平均年度效益额（万元）"
              header-align="center"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="sbqyngxl"
              label="申报前一年效益贡献率（%）"
              header-align="center"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="ty_yysr"
              label="营业收入(万元)"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ty_lyze"
              label="利润总额(万元)"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ty_jly"
              label="净利润(万元)"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ty_zcze"
              label="资产总额(万元)"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ty_fzze"
              label="负债总额(万元)"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ty_syzqyze"
              label="所有者权益总额(万元)"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ty_hwsr"
              label="海外收入(万元)"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ty_hwzc"
              label="海外资产(万元)"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ty_nsze"
              label="纳税总额(万元)"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ty_yffy"
              label="研发费用(万元)"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ty_cyry"
              label="从业人员(人)"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="ty_cyryrjnsr"
              label="从业人员人均年收入(万元)"
              header-align="center"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              prop="ty_aqscfy"
              label="安全生产费用(万元)"
              header-align="center"
              align="center"
              width="200"
            ></el-table-column>
            <el-table-column
              label="操作"
              header-align="center"
              align="center"
              width="100px"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="primary"
                  @click="downLoadReport(scope.row.ID)"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  name: "Jurisdiction",
  data() {
    return {
      id: "",
      total1: 1,
      tableData1: [],
      ChartsTabData: [],
      Page1: 1,
      value: "1",
      PageSize1: 10,
      user: "",
      isPopup: false,
      selName: "",
      usertype: "",
      show: false,
      loading: true,
      year: new Date().getFullYear().toString(), //element组件默认值为String，传数字会读取不出来
      pickerOptions: {
        // 禁选今日之后的时间,time是当前时间选择器的显示内容
        disabledDate(time) {
          const date = new Date(); //获取当前时间信息
          const year = date.getFullYear(); //获取当前年份
          const timeYear = time.getFullYear(); //获取时间选择器的所有年份
          // 2020之前与今年之后的全部禁用
          return timeYear < 2020 ? timeYear < 2020 : timeYear > year;
        },
      },
    };
  },
  created() {
    this.getinfo();
    this.id = JSON.parse(sessionStorage.getItem("userinfo")).ID;
  },
  methods: {
    downLoadAll() {
      // 一键下载
      // this.year
      var that = this;
      this.$message({
        message: "开始打包，请稍后！",
        type: "warning",
      });
      that.$axios
        .post(
          "excel/onepress?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            year: this.year,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            window.location.href = res.data.filepath;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "首次打包预计需要5分钟，请稍后再来下载。",
            type: "warning",
          });
        });
    },
    downLoadReport(item) {
      console.log(111);
      var that = this;
      that.$axios
        .post(
          "excel/zip?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            ID: item,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            window.location.href = res.data.filepath;
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },

    exportExcel() {
      /* 从表生成工作簿对象 */
      let fix = document.querySelector(".el-table__fixed-right");
      let wb;
      if (fix) {
        wb = XLSX.utils.table_to_book(
          document.querySelector(".el-table").removeChild(fix)
        );
        document.querySelector(".el-table").appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(document.querySelector(".el-table"), {
          raw: true,
        });
      }

      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: false,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          "我的成果管理.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    CurrentChange1(val) {
      //console.log(val)
      this.Page1 = val;
      //this.GetClass()
    },
    handleSizeChange1(val) {
      //console.log(val)
      this.PageSize1 = val;
      //this.GetClass()
    },
    setYear() {
      this.loading = true;
      this.getinfo();
    },

    getinfo(a) {
      if (a == 1) {
        this.Page1 = 1;
      }
      var that = this;
      that.$axios
        .post(
          "report/selectExamineCompanys?token=" +
            sessionStorage.getItem("token"),
          that.$qs.stringify({
            year: this.year,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.show = true;
            this.loading = false;
            this.tableData1 = res.data.data;

            // console.log(res.data.data);
            // console.log(this.tableData1);
            this.usertype = res.data.type;
            var reg = new RegExp("(zj+.)");

            if (this.usertype == 0) {
              this.tableData1.forEach((val) => {
                // if(val){

                var jzs = [];
                if (val.Status == 5) {
                  for (var key in val) {
                    if (reg.test(key)) {
                      jzs.push({
                        name: val[key].split(" ")[0],
                        score: val[key].split(" ")[1],
                      });
                    }
                  }
                }

                val.zjs = jzs;

                // console.log(val);
                // }
              });
            }
            // this.ChartsTabData= res.data.data.list;
            //this.total1 = res.data.data.total_num;
          } else {
            this.loading = false;
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
  },
  components: {
    Head,
    Foot,
    Nav,
  },
};
</script>
<style scoped lang="less">
.clear:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.btn {
  width: 1rem;
  cursor: pointer;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.17rem;
  text-align: center;
  background: #409eff;
  border-radius: 0.04rem;
  color: #fff;
}

.hotspot {
  width: 100%;
  min-width: 1000px;
  font-size: 0.16rem;
  padding: 0.28rem 2.54rem;
  box-sizing: border-box;

  .H-right {
    position: relative;
    width: 11.5rem;
    min-width: 750px;
    padding-left: 0.2rem;
    height: 100%;
    float: right;
    min-height: 7.4rem;
    border-left: 1px #eeeeee solid;

    .select {
      display: flex;
      align-items: center;
      margin-bottom: 0.2rem;

      select {
        width: 2rem;
        height: 0.4rem;
        margin-right: 0.2rem;
      }
    }

    .btn1 {
      background: #2d65d2;
      width: 1.3rem;
      height: 0.4rem;
      color: #fff;
      border-radius: 0.05rem;
      text-align: center;
      line-height: 0.5rem;
      line-height: 0.4rem;
      display: flex;
      position: absolute;
      right: 0rem;
      cursor: pointer;
      top: 1.1rem;
      z-index: 10;

      // justify-content: center;
      // align-items: center;
      i {
        margin: 0.03rem 0 0 0.07rem;
        width: 0.4rem;
        height: 0.4rem;
        background-image: url("../../assets/back/Excel.png");
        background-repeat: no-repeat;

        // background-size: 50%  100%;
      }
    }

    .btn2 {
      background: #fb8d10;
      width: 1.3rem;
      height: 0.4rem;
      color: #fff;
      border-radius: 0.05rem;
      text-align: center;
      line-height: 0.5rem;
      line-height: 0.4rem;
      display: flex;
      position: absolute;
      right: 1.5rem;
      cursor: pointer;
      top: 1.1rem;
      z-index: 10;

      i {
        margin: 0.03rem 0 0 0.07rem;
        width: 0.4rem;
        height: 0.4rem;
        background-image: url("../../assets/back/download.png");
        background-repeat: no-repeat;
        background-size: 80%;
      }
    }

    .t_main {
      /deep/ .el-table {
        max-height: 1200px !important;

        .el-table__body-wrapper {
          max-height: 1000px !important;
          overflow-x: auto;
        }

        .el-table__fixed-body-wrapper {
          max-height: 1000px !important;
        }
      }
    }

    .title {
      font-size: 0.4rem;
      margin: 0.2rem 0 0.5rem;
      text-align: center;
    }

    .sum {
      font-size: 0.18rem;
      margin-bottom: 0.1rem;
      color: #999;

      select {
        margin-right: 0.2rem;
        width: 1rem;
        height: 0.4rem;
      }
    }

    .H-header {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 0.5rem;

      span,
      select,
      div,
      input {
        margin-right: 0.2rem;
      }

      input,
      select {
        height: 0.4rem;
        width: 2rem;
        padding: 0.05rem;
      }
    }
  }
}

.Popup {
  width: 100%;
  position: absolute;
  top: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;

  .none {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .a_forms {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 10.11rem;

    background: white;
    font-size: 0.16rem;

    .f-top {
      height: 0.5rem;
      width: 100%;
      text-align: center;
      line-height: 0.5rem;
      position: relative;
      border-bottom: 1px #cfcfcf solid;

      img {
        position: absolute;
        right: 0.1rem;
        top: 50%;
        transform: translate(0, -50%);
      }
    }

    .f-info {
      padding: 0 0.54rem;

      .f-title {
        position: relative;
        overflow: hidden;
        padding-bottom: 0.5rem;
        border-bottom: 1px #cfcfcf solid;

        .f-left {
          overflow: hidden;
          position: relative;

          > img {
            margin-left: 1.2rem;
          }

          > div {
            margin: 0.3rem 0.18rem;
            vertical-align: top;

            > span {
              width: 0.8rem;
              text-align: justify;
              text-align-last: justify;
              color: #505050;
              display: inline-block;
            }

            > a {
              color: #505050;
              font-style: normal;
            }

            > em {
              margin-left: 0.3rem;
              color: #272727;
              font-style: normal;
            }
          }
        }

        .f-right {
          position: absolute;
          top: 0;
          right: 0;
          width: 50%;
        }
      }

      .f-bottom {
        margin: 0.2rem 0.2rem;
        display: flex;
        align-items: center;
      }
    }
  }
}

.set-popper {
  max-width: 500px;
}

.set-content {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.el-table__fixed-right {
  //height: 100% !important;

  //   height: calc(100% - 1000px) !important;
  //   &:before {
  //     height: 0;
  //   }
}
</style>
